import Image from 'next/image'
import fwbLogo from './fwb.png'

type IconProps = {
  className?: string
}

const FwbLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={fwbLogo} alt="FWB Logo" height={48} {...attributes} />
}

export default FwbLogo
